import React from 'react';

const HeaderBackBtnIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
      <path d="M16.5849 7.4984C16.8505 7.76406 16.9997 8.12433 16.9997 8.49998C16.9997 8.87563 16.8505 9.2359 16.5849 9.50157L10.5032 15.5833H26.9167C27.2924 15.5833 27.6528 15.7326 27.9184 15.9982C28.1841 16.2639 28.3334 16.6243 28.3334 17C28.3334 17.3757 28.1841 17.736 27.9184 18.0017C27.6528 18.2674 27.2924 18.4166 26.9167 18.4166H10.5032L16.5849 24.4984C16.843 24.7656 16.9858 25.1234 16.9826 25.4949C16.9793 25.8663 16.8303 26.2216 16.5677 26.4843C16.305 26.747 15.9497 26.896 15.5783 26.8992C15.2068 26.9024 14.849 26.7596 14.5818 26.5016L6.08177 18.0016C5.81619 17.7359 5.66699 17.3756 5.66699 17C5.66699 16.6243 5.81619 16.2641 6.08177 15.9984L14.5818 7.4984C14.8474 7.23282 15.2077 7.08362 15.5834 7.08362C15.959 7.08362 16.3193 7.23282 16.5849 7.4984Z" fill="#121212" />
    </svg>
  );
};

export default HeaderBackBtnIcon;
